import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=62c0d315&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=62c0d315&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0d315",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c0d315')) {
      api.createRecord('62c0d315', component.options)
    } else {
      api.reload('62c0d315', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=62c0d315&scoped=true", function () {
      api.rerender('62c0d315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/stock/structure/components/DataForm.vue"
export default component.exports